import { render, staticRenderFns } from "./HarnessSprite.vue?vue&type=template&id=167f1b3f&scoped=true&"
import script from "./HarnessSprite.vue?vue&type=script&lang=js&"
export * from "./HarnessSprite.vue?vue&type=script&lang=js&"
import style0 from "./HarnessSprite.vue?vue&type=style&index=0&id=167f1b3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f1b3f",
  null
  
)

export default component.exports